import React from 'react';
import DOMPurify from 'dompurify';
import { isExamDurationId } from '../../utils/examSubscriptionIds';

const money = value => `₹${Number(value || 0).toFixed(2)}`;

export default function ExamPlanSummary({ detail, price, durationId, onDuration, busy }) {
  const durations = Array.isArray(detail.subscription_price) ? detail.subscription_price : [];
  const subjects = Array.isArray(detail.subject_list) ? detail.subject_list : [];
  const discount = price && Number(price.actual_value) > Number(price.value)
    ? Math.round((1 - Number(price.value) / Number(price.actual_value)) * 100)
    : 0;

  return (
    <div className="exam-detail__plan">
      <h2 className="select-plan__titleA theme-color">Exam Subscription</h2>
      <h3 className="checkout-left__title exam-detail__plan-name">{detail.plan_name}</h3>

      {price ? (
        <>
          <div className="checkout-left__price-row exam-detail__price-row">
            <strong className="checkout-left__price">{money(price.value)}</strong>
            <span className="checkout-left__validity">/ {price.key}</span>
          </div>
          {price.actual_value != null && <del className="checkout-left__old-price exam-detail__old-price">{money(price.actual_value)}</del>}
          <div className="exam-detail__badges">
            <span className="exam-detail__validity"><i className="bi bi-clock" aria-hidden="true" /> Valid for {price.key}</span>
            {discount > 0 && <span className="exam-detail__discount"><i className="bi bi-tag-fill" aria-hidden="true" /> {discount}% OFF</span>}
          </div>
          {price.message && <p className="exam-detail__offer">{price.message}</p>}
        </>
      ) : <p role="alert">An active price for this duration is unavailable. Choose another duration.</p>}

      <div className="my-subscription__content-heading"><span>Select Subscription duration</span><div className="my-subscription__divider" /></div>
      <div className="select-plan__durations assessment-plan__durations exam-detail__durations" role="group" aria-label="Subscription duration">
        {durations.map((row, index) => {
          const validDuration = row.duration_id === null || isExamDurationId(row.duration_id);
          const selected = validDuration && (row.duration_id === null ? durationId === null || durationId === 0 : Number(row.duration_id) === durationId);
          return <button type="button" key={`${row.duration_id ?? 'unspecified'}:${index}`} className={`select-plan__duration ${selected ? 'select-plan__duration--selected' : ''}`} aria-pressed={selected} disabled={busy || !validDuration} onClick={() => onDuration(row.duration_id)}><span>{selected && <i className="bi bi-check2" aria-hidden="true" />}</span>{row.key}</button>;
        })}
      </div>

      <div className="exam-detail__subject-total"><span><i className="bi bi-book" aria-hidden="true" /> Total Subjects</span><strong>{subjects.length}</strong></div>
      {detail.plan_description && (
        <>
          <div className="my-subscription__content-heading"><span>Plan Description</span><div className="my-subscription__divider" /></div>
          <div className="checkout-left__description exam-detail__description" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(String(detail.plan_description)) }} />
        </>
      )}
    </div>
  );
}
